import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ArrowDownIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1996 24.0898C17.6109 24.6726 16.8129 25 15.9809 25C15.1488 25 14.3508 24.6726 13.7621 24.0898L1.91915 12.3541C1.33043 11.7703 0.999804 10.9785 1 10.153C1.0001 9.74422 1.08141 9.33949 1.2393 8.96189C1.39719 8.58428 1.62856 8.24121 1.9202 7.95224C2.21184 7.66328 2.55804 7.43408 2.93904 7.27775C3.32004 7.12141 3.72837 7.041 4.14071 7.04109C4.55306 7.04119 4.96135 7.1218 5.34227 7.27831C5.7232 7.43482 6.06929 7.66418 6.36079 7.95328L15.9809 17.4874L25.6009 7.9512C25.8904 7.65381 26.2368 7.41654 26.6197 7.25325C27.0027 7.08996 27.4147 7.00391 27.8315 7.00013C28.2484 6.99635 28.6619 7.0749 29.0478 7.23121C29.4338 7.38752 29.7844 7.61846 30.0794 7.91055C30.3743 8.20263 30.6076 8.55002 30.7656 8.93245C30.9237 9.31487 31.0033 9.72466 30.9999 10.1379C30.9965 10.5512 30.9101 10.9596 30.7457 11.3394C30.5813 11.7192 30.3423 12.0627 30.0426 12.35L18.1996 24.0939V24.0898Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
